import {useContext} from 'react';
import {Context as AddeparContext} from '../contexts/AddeparContext';

export const useAddepar = () => useContext(AddeparContext);
